export const BUTTON_STYLES = {
    secondary: 'secondary',
    tertiary: 'tertiary',
    primary: 'primary',
    invisible: 'invisible',
    toast: 'toast',
    toast_close: 'toast_close',
    danger: 'danger',
};

export const BUTTON_SIZES = {
    small: 'small',
    medium: 'medium',
    large: 'large',
    custom: 'custom',
};
